import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';
import { PromoEntity } from './promo.entity';

@Index('promo_item__fk_promo__id_index', ['fkPromoId'], {})
@Index('promo_item_item__id_fk', ['fkItemId'], {})
// Same item can be both BUY and GET on the same promo (same-set BOGO),
// so role is part of the uniqueness key.
@Index('promo_item_pk', ['fkPromoId', 'fkItemId', 'role'], { unique: true })
@Entity('promo_item')
export class PromoItemEntity extends BaseEntity {
	@Column('int', { name: '_fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	@Column('int', { name: '_fk_item__id', unsigned: true })
	public fkItemId!: number;

	// BUY = qualifier (what customer must purchase). GET = reward (discounted).
	// Non-BXGY promos use BUY only.
	@Column('varchar', { name: 'role', length: 8, default: () => "'BUY'" })
	public role!: 'BUY' | 'GET';

	@ManyToOne(() => ItemEntity, (item) => item.promoItems, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;

	@ManyToOne(() => PromoEntity, (promo) => promo.promoItems, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;
}
